import { BezierEdge, type EdgeProps } from "@xyflow/react";

export function DataEdge(props: EdgeProps) {
	return (
		<BezierEdge
			{...props}
			style={{
				stroke: "var(--forge-color-border)",
				strokeWidth: 2,
				opacity: 0.8,
			}}
		/>
	);
}
